import React, { useEffect, useRef, useState } from 'react';
import alarmAudio from '@/assets/mp3/alarm.mp3';
import blankAudio from '@/assets/mp3/blank.mp3';
import PushEvent, { TriggerAlarm } from '@/events/push-event';
import { Button, notification } from 'antd';

const audioTestKey = 'audio-test';
const alarmKey = 'alarm';

const AlarmNotification = () => {
  const [audio] = useState(new Audio());
  const isPlay = useRef(false);
  const [api, contextHolder] = notification.useNotification();

  useEffect(() => {
    checkAudioStatus();
    PushEvent.on(TriggerAlarm, triggerAlarmHandler);

    return () => {
      PushEvent.off(TriggerAlarm, triggerAlarmHandler);
      onClose();
    };
  }, []);

  const triggerAlarmHandler = () => {
    if (!isPlay.current) {
      api.warning({
        key: alarmKey,
        message: '报警',
        onClose,
        closeIcon: false,
        duration: 0,
        placement: 'topRight',
        style: {
          width: '200px',
        },
        btn: (
          <Button type="primary" onClick={() => { api.destroy(alarmKey); }}>
            关闭警报音
          </Button>
        ),
      });
      playAlarm();
      isPlay.current = true;
    }
  };

  const onClose = () => {
    pauseAlarm();
    isPlay.current = false;
  };

  const playAlarm = () => {
    audio.src = alarmAudio;
    audio.loop = true;
    audio.load();
    void audio.play().then(rr => {});
  };

  const pauseAlarm = () => {
    audio.pause();
  };

  const checkAudioStatus = () => {
    const checkAudio = new Audio();
    const closeNotification = () => {
      api.destroy(audioTestKey);
      window.removeEventListener('click', closeNotification);
    };

    checkAudio.src = blankAudio;
    checkAudio.loop = true;
    checkAudio.load();
    checkAudio
      .play()
      .then(r => {
        checkAudio.pause();
      })
      .catch(err => {
        console.warn(err);
        api.warning({
          key: audioTestKey,
          message: '解除音频锁定',
          duration: 0,
          description: '浏览器禁止播放音频，点击页面任意位置解除锁定.',
        });
        window.removeEventListener('click', closeNotification);
        window.addEventListener('click', closeNotification);
      });
  };

  return (
    <>{contextHolder}</>
  );
};

export default AlarmNotification;
